import baseAPI from '@/http'

const router = 'api/UsuarioGrupoPermissao'

export const groupsPermissionAPI = {
    update: (configuracao) => baseAPI.put(router, configuracao),
    get: () => baseAPI.get(`${router}`),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    create: (configuracao) => baseAPI.post(router, configuracao),
    getByGroup: (groupId) => baseAPI.get(`${router}/get-by-grupo/${groupId}`)

}

